/**
 * Shared form validation utilities for the inspire-events package
 */

import type { RuleObject } from "antd/es/form";

/**
 * Validates a US zip code (5 digits)
 */
export const isValidZipCode = (value: string): boolean => {
  return !!value && value.length === 5 && !isNaN(Number(value));
};

/**
 * Ant Design form validation rule for US zip codes
 * Usage: rules={[zipCodeValidationRule]}
 */
export const zipCodeValidationRule: RuleObject = {
  required: true,
  message: "Please enter your zip code.",
  validator(_, value) {
    if (isValidZipCode(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Please enter a valid zip code."));
  },
};
